import React from 'react';

//domains
import type {
  SanityDocBlog,
  SanityBlogTag,
  SanityBlogCategory,
} from 'domains/blog';

//components
import {Link} from 'components/Link';
import BlogCard from './BlogCard';

interface Props {
  recentBlogs: SanityDocBlog[];
  tags: SanityBlogTag[];
  categories: SanityBlogCategory[];
  blogSettings: {
    blogs_label: string;
    categories_label: string;
    tags_label: string;
    recent_posts_label: string;
  };
}

export default function BlogListingSidebar({
  recentBlogs,
  categories,
  tags,
  blogSettings,
}: Props) {
  return (
    <div className="flex flex-col space-y-10 md:col-span-1 pb-10">
      <div className="">
        <header className="mb-6">
          <h4 className="text-[20px] font-semibold">
            {blogSettings?.recent_posts_label}
          </h4>
        </header>
        <ul className="grid gap-4">
          {recentBlogs &&
            recentBlogs.map((b) => (
              <li
                key={`blog-sidebar-${b._id}`}
                className="border-b border-black pb-4"
              >
                <BlogCard {...b} size="small" />
              </li>
            ))}
        </ul>
      </div>
      {categories && (
        <div className="">
          <header className="mb-6">
            <h4 className="text-[20px] font-semibold">
              {blogSettings?.categories_label}
            </h4>
          </header>
          <ul className="grid gap-6">
            {categories.filter(c => c.slug.current !== 'all').map((c) => {
              return (
                <li key={c._rev} className="border-b border-black pb-4">
                  <article className="blog">
                    <Link to={`/blogs/${c.slug.current}`}>
                      <h5 className="font-normal">{c.category_title}</h5>
                    </Link>
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {tags && (
        <div className="">
          <header className="mb-6">
            <h4 className="text-[20px] font-semibold">
              {blogSettings?.tags_label}
            </h4>
          </header>
          <ul className="flex flex-wrap">
            {tags.map((t) => {
              return (
                <li key={t._rev} className="border-b border-black mr-4 mb-4">
                  <article className="blog">
                    <Link to={`/blogs/tags/${t.slug.current}`}>
                      <h5 className="font-normal">{t.title}</h5>
                    </Link>
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
